export default __webpack_public_path__ + "static/media/mern.027ba0d2.png";